export enum ClinicsView {
  Default = 'default',
  ParentToChild = 'parentToChild',
}
